import { ANYONE_ID } from 'Calendar/anyone';
import { loadingPageSignal } from 'components/LoadingPage';
import moment from 'moment';
import QuickBookContext from 'QuickBooking/Context';
import qbSignal from 'QuickBooking/signal';
import apis from 'services/apis';
import { ICustomerUI } from 'types/customer';
import { getSystemMomentFormat } from 'utils/time';
import toast from 'utils/toast';

const useCallerId = () => {
  const book = async (callerId: string, _customer?: ICustomerUI | undefined) => {
    const result = await QuickBookContext.caller(callerId, _customer);
    if (!result) return;
    const { customer, staff, timeSlot } = result;
    qbSignal.open(staff?.id || '', getSystemMomentFormat(timeSlot) || '', { customer, callerId, requestStaff: staff?.id === ANYONE_ID ? false : true });
  };

  const sms = async (id: string, customer?: ICustomerUI | undefined) => {
    if (!customer) return;
    loadingPageSignal.value = true;
    try {
      const res: any = await apis.sendSmsBookingOnline(id, customer.phone);
      if (res.data.payload) {
        toast.success('Send SMS successfully');
      }
    } catch (error) {
    } finally {
      loadingPageSignal.value = false;
    }
  };

  // Đánh dấu caller spam. Trả về false khi lỗi để caller không refetch/ẩn card oan.
  const skip = async (id: string) => {
    loadingPageSignal.value = true;
    try {
      const res: any = await apis.skipCaller(id);
      // payload=false nghĩa là BE không đánh dấu được → xử lý như thất bại.
      if (res?.data?.payload) return true;
    } catch (error) {
    } finally {
      loadingPageSignal.value = false;
    }
    // Nuốt lỗi im lặng thì card vẫn nằm đó mà nhân viên không hiểu tại sao.
    toast.error('Skip failed');
    return false;
  };

  return ({ book, sms, skip });
};

export default useCallerId;
